
import './App.css';
import Bio from "./components/Bio/Bio"
import Navigation from "./components/Navigations/Navigations"
import Footer from "./components/Footer/Footer"

function App() {
  return (
    <div className="App">
      <Bio />
      <Navigation />
      <Footer />
    </div>
  );
}

export default App;
